<template>
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path fill-rule="evenodd" clip-rule="evenodd"
      d="M24 6.69592L17.3417 0L14.2194 3.12226L0 17.3041V24H6.69592L21.4044 9.32915L24 6.69592ZM21.8934 6.69592L20.3135 8.27586L15.7618 3.68652L17.3041 2.10658L21.8934 6.69592ZM1.5047 19.4483L4.62696 22.4953H1.5047V19.4483ZM6.39498 22.1567L1.76803 17.6426L14.6708 4.77743L19.2602 9.32915L6.39498 22.1567Z"
      fill="var(--brandPrimary)" />
  </svg>
</template>
